import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api/dashboard/DashboardNotesReq';
import BackButton from "../components/BackButton";
import { toast } from 'sonner';
import { FaMagnifyingGlass } from "react-icons/fa6";
import { GrCheckboxSelected } from "react-icons/gr";
import DateInput from "../components/InputDate";
import TimeInput from "../components/InputTime";
import { format } from 'date-fns';
import { RiResetLeftFill } from "react-icons/ri";


const Notes = () => {
    const [currentLink, setCurrentLink] = useState('');
    const { flow_meter_id, from_datetime, to_datetime} = useParams();
    const navigate = useNavigate();
    const [stateOfLink, setStateOfLink] = useState('get');
    const [linkId, setLinkId] = useState('');

    const [selectedFromDate, setSelectedFromDate] = useState(format(from_datetime, 'yyyy-MM-dd'));
    const [selectedFromTime, setSelectedFromTime] = useState(format(from_datetime, 'HH:mm:ss'));
    const [selectedToDate, setSelectedToDate] = useState(format(to_datetime, 'yyyy-MM-dd'));
    const [selectedToTime, setSelectedToTime] = useState(format(to_datetime, 'HH:mm:ss'));

    const handleChangeFromDate = (event) => {
        setSelectedFromDate(event.target.value)
    };
    const handleChangeFromTime = (event) => {
        setSelectedFromTime(event.target.value)
    };
    const handleChangeToDate = (event) => {
        setSelectedToDate(event.target.value)
    };
    const handleChangeToTime = (event) => {
        setSelectedToTime(event.target.value)
    };

    const handleOpenNotesWithCurrentLink = (e) => {
        e.preventDefault()
        window.open(currentLink, '_blank');
        navigate(`/dashboard/dashboard/${flow_meter_id}/${from_datetime}/${to_datetime}`);
    }

    const handleSubmitChangeLink = async (e) => {
        e.preventDefault()
        const dateTimeFromBeforeParsing = `${selectedFromDate}T${selectedFromTime}`
        const dateTimeToBeforeParsing = `${selectedToDate}T${selectedToTime}`
        
        if (stateOfLink === 'put') {
            putLink(dateTimeFromBeforeParsing, dateTimeToBeforeParsing)
        } else if (stateOfLink === 'post') {
            postLink(dateTimeFromBeforeParsing, dateTimeToBeforeParsing)
        }
    }

    const reloadPage = () => {
        window.location.reload();
    }

    const handleChangeCurrentLink = (e) => {
       setCurrentLink(e.target.value);
    }

    const getLink = async () => {
        try {
            const response = await api.get(
                `/available-link/${flow_meter_id}/${from_datetime}/${to_datetime}`,
                {withCredentials: true}
            );
            if (response.data.success) {
                if (response.data.payload == null) {
                    setStateOfLink('post');
                    toast.success('Ready to add new link!')
                }
                else {
                    setStateOfLink('put');
                    const replacedDatetimefrom =  response.data.payload[0].datetime_from.replace("Z", "");
                    const replacedDatetimeto =  response.data.payload[0].datetime_to.replace("Z", "");

                    setCurrentLink(response.data.payload[0].link);
                    setSelectedFromDate(format(replacedDatetimefrom, 'yyyy-MM-dd'));
                    setSelectedFromTime(format(replacedDatetimefrom, 'HH:mm:ss'));
                    setSelectedToDate(format(replacedDatetimeto, 'yyyy-MM-dd'));
                    setSelectedToTime(format(replacedDatetimeto, 'HH:mm:ss'));
                    setLinkId(response.data.payload[0].id);
                    toast.success('Ready to update or delete link!');
                }
            } else {
                console.error('Error: ', response.data.message);
            }
        } catch (err) {
            console.log(err.response);
        }
    };

    const putLink = async (datetimefrom, datetimeto) => {
        try {
            const response = await api.put(
                '/update-link',
                {
                    id: linkId,
                    flow_meter_id: flow_meter_id,
                    datetime_from: datetimefrom,
                    datetime_to: datetimeto,
                    link: currentLink,
                },
                {
                    withCredentials: true
                }
            );
            if (response.data.success) {
                toast.success(response.data.message);
                setCurrentLink(response.data.payload[0].link);
            } else {
                toast.error(response.data.message)
            }
        } catch (err) {
            toast.error('Some other error occured!')
        }
    };

    const postLink = async (datetimefrom, datetimeto) => {
        try {
            const response = await api.post(
                '/',
                {
                    flow_meter_id: flow_meter_id,
                    datetime_from: datetimefrom,
                    datetime_to: datetimeto,
                    link: currentLink,
                },
                {
                    withCredentials: true
                }
            );
            if (response.data.success) {
                setCurrentLink(response.data.payload[0].link);
                setLinkId(response.data.payload[0].id);
                setStateOfLink('put');
                toast.success(`${response.data.message} Ready to update or delete link!`);
            } else {
                toast.error(response.data.message)
            }
        } catch (err) {
            toast.error('Some other error occured!')
        }
    }

    const deleteLink = async () => {
        try {
            const response = await api.delete(`delete-link/${linkId}`, {withCredentials: true});
            if (response.data.success) {
                toast.success(response.data.message);
                setCurrentLink('');
                setLinkId('');
                setStateOfLink('post');
            } else {
                toast.error(response.data.message)
            }
        } catch (err) {
            toast.error('Some other error occured!')
        }
    }

    useEffect(() => {
        getLink();
    }, []);

    return (
        <div className='notes-container'>
            <h2 className='notes-title'>
                Notes &nbsp; 
                <button className="manage-uploaded-data-button-reset" onClick={() => reloadPage()}> <RiResetLeftFill /> </button>
            </h2>
            <form
                className='notes-current-link-form'
                onSubmit={handleSubmitChangeLink}
            >
                <h3 className='notes-form-title'>Current link:</h3>
                <textarea
                    type='text'
                    className='notes-textarea'
                    value={currentLink}
                    onChange={handleChangeCurrentLink}
                />
                <div className="notes-date-time-container">
                    FROM:
                    <div className="">    
                        <DateInput 
                            selectedDate={selectedFromDate}
                            handleSelectedDate={handleChangeFromDate}
                        />
                        <TimeInput 
                            selectedTime={selectedFromTime}
                            handleSelectedTime={handleChangeFromTime}
                        /> 
                    </div>
                </div>
                <div className="notes-date-time-container">
                    TO:
                    <div className="">
                        <DateInput 
                            selectedDate={selectedToDate}
                            handleSelectedDate={handleChangeToDate}
                        />
                        <TimeInput 
                            selectedTime={selectedToTime}
                            handleSelectedTime={handleChangeToTime}
                        />
                    </div>
                </div>
                {
                    stateOfLink === 'put'?
                    <div className='notes-button-submit-delete-wrapper'>
                        <button
                            type='submit'
                            className='dashboard-button notes-button-change-link'
                        >
                            Change 
                        </button>
                        <button type="button" className='notes-delete-button' onClick={deleteLink}>
                            Delete
                        </button>
                    </div> :
                    <button
                        type='submit'
                        className='dashboard-button notes-button-change-link'
                    >
                        Change
                    </button>
                }
            </form>
            <button className='notes-button' onClick={handleOpenNotesWithCurrentLink}>
                    Open notes with current link <FaMagnifyingGlass />
            </button>
            <BackButton
                navigateTo={`/dashboard/dashboard/${flow_meter_id}/${from_datetime}/${to_datetime}`}
            />
        </div>
    )
}

export default Notes;